import React from 'react';
export interface CourseKpi {
  label: string;
  value: string;
  detail?: string;
  tone?: 'default' | 'positive' | 'negative' | 'attention';
}
interface CourseKpiCardsProps {
  items: CourseKpi[];
}
const toneClass = {
  default: 'text-seform-navy',
  positive: 'text-green-700',
  negative: 'text-red-600',
  attention: 'text-amber-700'
};

// Small summary cards at the top of the course dashboard
export function CourseKpiCards({
  items
}: CourseKpiCardsProps) {
  return <dl className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6" data-id="element-1204" data-mp="15o9i0l89x8t2">
      {items.map(item => <div key={item.label} className="rounded-xl border border-slate-200 bg-white px-4 py-3" data-id="element-1205" data-mp="qr0pvpb5c10a">
          <dt className="text-xs font-medium text-slate-500" data-id="element-1206" data-mp="vpal1zwvf1lw">{item.label}</dt>
          <dd className={`mt-1 text-xl font-bold tabular-nums ${toneClass[item.tone || 'default']}`} data-id="element-1207" data-mp="3bh7z0teybqy9">
            {item.value}
          </dd>
          {item.detail && <p className="text-xs text-slate-400 mt-0.5 truncate" data-id="element-1208" data-mp="3nev9ye4cojtg">{item.detail}</p>}
        </div>)}
    </dl>;
}